var _path, _path2, _path3, _rect, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1559 24.3727C15.1967 24.0318 15.689 23.8069 15.689 22.7072C15.689 22.3757 15.7127 21.7339 15.424 21.4864C14.2865 20.5114 12.7437 20.5616 11.8469 21.6378C11.413 22.1584 10.4737 24.032 9.69867 24.032C8.23095 24.032 7.17196 23.723 7.17196 22.1678C7.17196 20.9283 9.24331 21.9374 9.42423 22.8018C9.66783 23.9657 9.15561 25.1695 8.02366 25.7354C7.26867 26.1129 5.36529 26.1227 4.74934 25.5273C3.64468 24.4594 3.59481 23.3855 3.59481 21.988",
    stroke: "#717070",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5321 2.36061C16.301 1.44595 17.6658 1.32777 18.5804 2.09665C19.4951 2.86552 19.6133 4.2303 18.8444 5.14496L14.9549 9.77188L11.6426 6.98753L15.5321 2.36061Z",
    fill: "white",
    stroke: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91679 18.7448C6.75112 18.9418 6.54473 19.1007 6.31181 19.2104C4.93438 19.8593 3.42983 18.5946 3.8323 17.1261C3.90036 16.8778 4.02138 16.6472 4.18706 16.4501L5.36646 15.0471L8.09619 17.3417L6.91679 18.7448Z",
    fill: "white",
    stroke: "#717070"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2895,
    y: 7.99695,
    width: 3.56608,
    height: 8.9164,
    transform: "rotate(40.051 11.2895 7.99695)",
    fill: "white",
    stroke: "#717070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31641 19.064L3.40485 20.1484",
    stroke: "#717070",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2825 4.80928C19.6075 4.6198 19.8548 4.36503 20.3208 4.75678C20.7868 5.14853 20.4924 5.73533 20.2197 6.05976C19.7639 6.60195 18.789 7.1704 17.8774 8.25479C17.2697 8.97772 16.3987 10.2504 16.8647 10.6422C17.3308 11.0339 17.7511 10.7704 17.903 10.5897",
    stroke: "#717070",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.ed22698784be55f11f09e16144055253.svg";
export { ForwardRef as ReactComponent };